import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { gaEvent } from "../../lib/analytics";

// Scrolls to the quote form on the Contact page (animated via Lenis).
export function scrollToQuote() {
  const el = document.getElementById("quote");
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export default function QuoteButton({
  label = "Request a Free Quote",
  variant = "gold",
  size = "md",
  className = "",
  testId = "request-quote-btn",
}) {
  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full font-medium transition-all duration-300 will-change-transform";
  const sizes = {
    sm: "px-5 py-2.5 text-sm",
    md: "px-7 py-3.5 text-sm",
    lg: "px-9 py-4 text-base",
  };
  const variants = {
    gold: "bg-gold text-charcoal hover:bg-gold-light hover:-translate-y-0.5 shadow-[0_10px_30px_-12px_rgba(196,162,101,0.7)]",
    outline:
      "border border-gold/60 text-ink hover:border-gold hover:bg-gold/10 hover:-translate-y-0.5",
    light:
      "bg-cream text-charcoal hover:bg-white hover:-translate-y-0.5",
    dark: "bg-charcoal text-cream hover:bg-charcoal-soft hover:-translate-y-0.5",
  };

  return (
    <Link
      to="/contact#quote"
      data-testid={testId}
      onClick={() => gaEvent("quote_cta_click", { cta_location: testId })}
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
    >
      {label}
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </Link>
  );
}
